import { ButtonMui } from 'src/components/ButtonMui'
import styled from 'styled-components'

export const ContainerButtons = styled.div`
    display: flex;
    flex-direction: column;
    gap: .6rem;
`

export const CustomButton = styled(ButtonMui)`
    width: 100%;
    height: 2.5rem !important;
    margin: 0 !important;
`
